import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { SignInPage } from '../../components/SignInPage/SignInPage';
import { SignInPhoneForm } from '../../components/SignInPhoneForm/SignInPhoneForm';
import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignInPhone = () => (
  <SignInPage>
    <SignInPhoneForm />
    <Typography variant="body2">
      New to Safi?&nbsp;
      <Link component={RouterLink} to={getAuthRoute('/sign-up')}>
        Create your account
      </Link>
    </Typography>
  </SignInPage>
);
